import { Ifetch } from "../initialState";

export interface IMostObservedSpecies {
  count: number;
  name: string;
}

export interface IfetchMostObservedSpecies extends Ifetch {
  data: IMostObservedSpecies[];
  totalCount: number;
}

const mostObservedSpeciesInitialState: IfetchMostObservedSpecies = {
  data: [],
  totalCount:0,
  message: "",
  stateIs: "Pending",
};
export default mostObservedSpeciesInitialState;
